import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { get } from "lodash";
import { STATIC_KEYWORDS } from "../../../constants";
// import { SvgIconHandler } from "../SvgIconHandler";
import EntitySvg from "../EntitySvg";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./entity-listing-story.m.css";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

export const EntityListingStory = ({ story, config, isStoryHeader=false }) => {
  const { tags } = story;
  const { PROFILES_MENTIONED, IN_THIS_STORY } = STATIC_KEYWORDS;
  const filteredTags = tags?.filter((tag) => tag["tag-type"] === "Entity") || [];
  const [listopen, setListOpen] = useState(false);
  const allStates = useSelector((state) => state);
  const storyHeaderInView = get(allStates, "storyHeaderInView", true);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  const isWebView = get(allStates, ["qt", "config", "isWebView"]) === true;

  useEffect(() => {
    document.body.style.overflow = listopen ? "hidden" : "unset";
  }, [listopen]);

  return (
    <React.Fragment>
      {filteredTags.length > 0 && !listopen && !isDesktop && !isWebView && (
        <div
          id="entity-list-floating-btn"
          styleName={`mobile-btn ${!storyHeaderInView ? "small-mobile-btn" : ""} ${isStoryHeader ? 'story-header' : ''}`}
          onClick={() => {
            const { category, subCategory, contentId } = getCategoryAndSubCategory(
              window.location,
              "story-page",
              config,
              story
            );
            if (typeof window !== "undefined" && window.dataLayer) {
              window.dataLayer.push({
                event: "dl_story_interactions",
                event_action: "entity_in_this_story_clicks",
                category,
                sub_category: subCategory,
                content_id: contentId,
                template_name: getTemplateName(story?.["story-template"] || pageType),
                platform: window.innerWidth >= 768 ? "desktop" : "mobile",
              });
            }
            setListOpen(true);
          }}
        >
          <EntitySvg />
          {storyHeaderInView && <span styleName="mobile-btn-text">{IN_THIS_STORY}</span>}
        </div>
      )}
      {listopen && <div styleName="blur-bg" onClick={() => setListOpen(false)} />}
      {filteredTags.length > 0 && (
        <div id="entity-list" styleName={`table-container ${listopen ? "open" : ""}`}>
          <div styleName="heading-container">
            <div styleName="heading">{PROFILES_MENTIONED}</div>
            <span styleName="cross" onClick={() => setListOpen(false)}>
              {/* <SvgIconHandler type="close" width="20" height="20" viewBox="0 0 20 20" /> */}
            </span>
          </div>
          <hr styleName="line" />
          <div styleName="list-container">
            {filteredTags.map((tag, index) => (
              <React.Fragment key={tag.id}>
                <a
                  key={index}
                  styleName="list-item"
                  href={`${config?.["sketches-host"]}/${tag.type === "company" ? "companies" : "people"}/${tag.slug}`}
                  onClick={(e) => {
                    const { category, subCategory, contentId } = getCategoryAndSubCategory(
                      window.location,
                      "story-page",
                      config,
                      story
                    );
                    e.preventDefault();
                    if (typeof window !== "undefined" && window.dataLayer) {
                      window.dataLayer.push({
                      event: "dl_story_interactions",
                      event_action: "entity_list_click",
                      link_text: tag.name,
                      link_url: `${config?.["sketches-host"]}/${tag.type === "company" ? "companies" : "people"}/${
                        tag.slug
                      }`,
                      category,
                      sub_category: subCategory,
                      content_id: contentId,
                      template_name: getTemplateName(story?.["story-template"] || "story-page"),
                      platform: window.innerWidth >= 768 ? "desktop" : "mobile",
                    });
                    }
                    const url = `${config?.["sketches-host"]}/${tag.type === "company" ? "companies" : "people"}/${
                      tag.slug
                    }`;
                    setTimeout(() => {
                      window.location.href = url;
                    }, 100);
                  }}
                >
                  {tag.name}
                </a>
                {index !== filteredTags.length - 1 && <hr styleName="inner-line" />}
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

EntityListingStory.propTypes = {
  story: PropTypes.object,
};
